
import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div className="container mt-5">
      <h1>Welcome to the Cooking Recipes App</h1>
      <p>This is your one-stop shop for managing your weekly meals.</p>
      <div className="d-grid gap-2 col-6 mx-auto">
        <Link to="/recipes" className="btn btn-primary">View All Recipes</Link>
        <Link to="/add" className="btn btn-primary">Add a New Recipe</Link>
        <Link to="/weekly-overview" className="btn btn-primary">Weekly Meal Plan</Link>
      </div>
    </div>
  );
};

export default Home;
